package com.milta.core.localization.translations.ro

import com.milta.core.localization.SpreadsheetImportStrings

internal val SpreadsheetImport = SpreadsheetImportStrings(
    importFileTitle = "Importă un fișier",
    analysingTitle = "Se analizează fișierul…",
    analysingSubtitle = "Identificăm coloanele și detectăm livrările din tabel.",
    fileSentSuffix = "trimis chiar acum",
    structuredFormatBannerTitle = "Format recunoscut.",
    structuredFormatBannerMessage = "Coloanele au fost mapate automat, nu este necesară nicio corecție.",
    columnsInterpretedBannerTitle = "Coloane interpretate automat.",
    columnsInterpretedBannerMessage = "Verificați livrările semnalate înainte de a le adăuga.",
    completePillLabel = "Totul este complet",
    invalidFileTitle = "Fișier neacceptat.",
    invalidFileMessage = "Importați un fișier Excel (.xlsx) sau CSV (.csv) valid.",
    chooseAnotherFileButton = "Alegeți alt fișier",
    extractionFailedTitle = "Acest fișier nu poate fi citit.",
    extractionFailedMessage = "Tabelul pare gol sau structura sa nu a fost recunoscută — verificați conținutul sau introduceți livrările manual.",
    retryWithNewFileButton = "Reîncercați cu alt fișier",
    serviceUnavailableTitle = "Serviciul de analiză este temporar indisponibil.",
    serviceUnavailableMessage = "Reîncercați în câteva momente sau completați această livrare manual până atunci.",
)
